<template>
  <el-select
    v-model="selectValue"
    style="width:100%"
    :remote-method="remoteMethod"
    :remote="isRemote"
    :filterable="isFilterable"
    :placeholder="placeholder"
    :multiple="isMultiple"
    @change="change"
  >
    <el-option
      v-for="item in list"
      :key="optionKey ? item[optionKey.value] : item.value"
      :label="optionKey ? item[optionKey.label] : item.label"
      :disabled="isDisabled(item)"
      :value="optionKey ? item[optionKey.value] : item.value"
    >
      <!-- 如果下拉框要显示多个文本，循环’showLabel‘ -->
      <span v-if="showLabel.length > 0" class="labelAll">
        <span v-for="itemIndex in showLabel" :key="itemIndex+''">{{ item[itemIndex] }}</span>
      </span>
      <span v-else>{{ optionKey ? item[optionKey.label] : item.label }}</span>
    </el-option>
  </el-select>
</template>
<script>
import { selectHttp } from '@/api/system/rightsManagement'
export default {
  name: 'Select',
  props: {
    // eslint-disable-next-line vue/require-default-prop
    value: [Number, String, Array],
    // eslint-disable-next-line vue/require-default-prop
    options: String, // option选项列表JSON串，如此项有值，则直接用此选项中的数据，不会进行数据请求去获取数据。即优先级options>url。默认为空，非必传。
    url: { // 需要请求的接口url
      type: String,
      default: ''
    },
    // eslint-disable-next-line vue/require-default-prop
    optionKeys: String, // 接口搜索的参数
    // eslint-disable-next-line vue/require-default-prop
    urlParams: String, // 接口搜索的参数
    isSelect: { // 是否默认请求接口
      type: Boolean,
      default: false
    },
    // eslint-disable-next-line vue/require-default-prop
    searchName: String, // 搜索条件
    isRemote: { // 是否为远程搜索
      type: Boolean,
      default: false
    },
    isFilterable: { // 是否可搜索
      type: Boolean,
      default: false
    },
    isMultiple: { // 是否多选
      type: Boolean,
      default: false
    },
    item: { // 额外用到的参数,需要通过子组件传回去
      type: Object,
      default: null
    },
    placeholder: { // 选择框提示文字，默认‘请选择’，非必传。
      type: String,
      default: '请选择'
    },
    // eslint-disable-next-line vue/require-default-prop
    showLabels: String, // 下拉选项展示值字符串，逗号隔开，若此项有值，则下拉选项所展示文字不再用'label'的值，以此项设置为准，展示时按照顺序展示出来，如展示两个值，则在下拉框中是左右排列，如展示三个值及以上，则第一个和最后一个左右排列，其余值中间分布显示。默认空，非必传。
    // eslint-disable-next-line vue/require-default-prop
    disables: String // 禁止选择的属性值，逗号隔开，非必传。
  },
  data () {
    return {
      list: [],
      pageSize: 100,
      pageNo: 1,
      selectValue: this.value,
      optionKey: null,
      requestParams: null,
      showLabel: []
    }
  },
  watch: {
    value () {
      this.selectValue = this.value
    },
    options () {
      if (this.options) {
        this.list = JSON.parse(this.options)
      }
    },
    urlParams: {
      async handler () {
        this.requestParams = this.urlParams ? JSON.parse(this.urlParams) : null
        this.list = await this.getList()
        this.$emit('getList', this.list)
      },
      deep: true
    },
    optionKeys () {
      this.optionKey = this.optionKeys ? JSON.parse(this.optionKeys) : null
    },
    showLabels () {
      this.showLabel = this.showLabels ? this.showLabels.split(',') : []
    }
  },
  async created () {
    this.optionKey = this.optionKeys ? JSON.parse(this.optionKeys) : null
    this.showLabel = this.showLabels ? this.showLabels.split(',') : []
    this.requestParams = this.urlParams ? JSON.parse(this.urlParams) : null
    if (this.options) { // 如果父组件有下拉选项数据，则不进行数据请求
      this.list = JSON.parse(this.options)
    }
    if (this.url) {
      this.list = await this.getList()
    }
    if (this.value) {
      let isBool = false
      this.list = await this.getList()
      this.list.forEach(item => { // 判断value是否能匹配上list中的数据,如果能匹配上则给值,匹配不上给请选择
        if (this.optionKey !== null) {
          if (item[this.optionKey.value] === this.value) {
            isBool = true
          }
        } else {
          if (item.value === this.value) {
            isBool = true
          }
        }
      })
      if (isBool) {
        this.selectValue = this.value
      } else {
        this.selectValue = '请选择'
      }
    }
  },
  methods: {
    // 下拉数据
    getList (val) {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.pageNo
      }
      if (this.requestParams) {
        params = Object.assign(params, this.requestParams)
      }
      if (val !== '' || val !== undefined) { // 远程搜索条件
        params[this.searchName] = val
      }
      return new Promise((resolve, reject) => {
        // selectHttp(this.url, params).then(res => {
        //   if (res.data.errcode === '0') {
        //     resolve(res.data.data.list)
        //   } else {
        //     reject(this.$message.error(res.data.errmsg))
        //   }
        // }).catch(err => {
        //   console.log(err)
        // })
      })
    },
    isDisabled (item) {
      if (this.disables) {
        const dicList = this.disables.split(',')
        const itemValue = this.optionKey ? item[this.optionKey.value] : item.value
        const findItemIndex = dicList.findIndex(itemD => itemD === itemValue)
        if (findItemIndex > -1) { return true }
        return false
      }
      return false
    },
    change (val) {
      let valueKey = 'value'
      if (this.optionKey) { valueKey = this.optionKey.value }
      if (this.isMultiple) {
        const valObjList = []
        val.forEach(element => {
          const valObj = this.list.find(itemO => itemO[valueKey] === element)
          valObjList.push(valObj)
        })
        this.$emit('change', val, valObjList)
      } else {
        const valOption = this.list.filter(itemO => itemO[valueKey] === val)
        const [valObj] = valOption
        this.$emit('change', val, valObj, this.item)
      }
    },
    /**
  * 下拉框出现/隐藏时触发
  * @isShow {Boolean} 标识：true为下拉框展开；false为下拉框隐藏
  **/
    visibleChange (isShow) {
      this.$emit('visibleChange', isShow)
    },
    // 远程搜索
    async remoteMethod (query) {
      this.list = await this.getList(query !== '' ? query : undefined)
    }
  }
}
</script>
